import {colormap} from "@/services/colorValues.js"

export const rescale_score_by_abs = function (score, max_score, min_score) {
    // rescale positive score to the range [0.5, 1.0], negative score to the range [0.0, 0.5],
    // using the extremal scores max_score and min_score for normalization
    let upperInc = 0.15

    // CASE 1: positive AND negative scores occur --------------------
    if (max_score > 0 && min_score < 0) {


        if (max_score >= Math.abs(min_score)) {
            // deepest color is positive
            if (score >= 0) {
                return 0.5 + upperInc * (score / max_score);
            } else {
                return 0.5 - 0.5 * (Math.abs(score) / max_score);
            }
        } else {
            // deepest color is negative
            if (score >= 0) {
                return 0.5 + upperInc * (score / Math.abs(min_score));
            } else {
                return 0.5 - 0.5 * (score / min_score);
            }
        }
    }
    // CASE 2: ONLY positive scores occur -----------------------------
    else if (max_score > 0 && min_score >= 0) {
        if (max_score === min_score) {
            return 1.0;
        } else {
            return 0.5 + upperInc * (score / max_score);
        }
    }
    // CASE 3: ONLY negative scores occur -----------------------------
    else if (max_score <= 0 && min_score < 0) {
        if (max_score === min_score) {
            return 0.0;
        } else {
            return 0.5 - 0.5 * (score / min_score);
        }
    } else {
        return 0.5;
    }
}
export const enforceBounds = function (x) {
    if (x < 0) {
        return 0;
    } else if (x > 1) {
        return 1;
    } else {
        return x;
    }
}

let brightness = function (r, g, b) {
    return (r * 299 + g * 587 + b * 114) / 1000
}


export const interpolateLinearly = function (x, scheme) {

    let values = colormap[scheme]
    // Split values into four lists
    var x_values = [];
    var r_values = [];
    var g_values = [];
    var b_values = [];
    for (i in values) {
        x_values.push(values[i][0]);
        r_values.push(values[i][1][0]);
        g_values.push(values[i][1][1]);
        b_values.push(values[i][1][2]);
    }
    var i = 1;
    while (x_values[i] < x) {
        i = i + 1;
    }
    i = i - 1;
    var width = Math.abs(x_values[i] - x_values[i + 1]);
    var scaling_factor = (x - x_values[i]) / width;
    // Get the new color values though interpolation
    var r = r_values[i] + scaling_factor * (r_values[i + 1] - r_values[i])
    var g = g_values[i] + scaling_factor * (g_values[i + 1] - g_values[i])
    var b = b_values[i] + scaling_factor * (b_values[i + 1] - b_values[i])
    return [enforceBounds(r), enforceBounds(g), enforceBounds(b)];
}

export const getStyles = function (score, colorScheme) {
    let background = ""
    let text_color = ""
    if (Math.abs(score - 0.5) <= 0.1) {
        background = ""
        text_color = "rgb(0,0,0)";
    }
    else {
        let color = interpolateLinearly(score, colorScheme);
        let r = Math.round(255 * color[0]);
        let g = Math.round(255 * color[1]);
        let b = Math.round(255 * color[2]);
        background = 'rgb(' + r + ', ' + g + ', ' + b + ')'
        let bright = brightness(r, g, b);

        text_color = "rgb(0,0,0)";
        if (bright < 123) {
            text_color = "rgb(255,255,255)";
        }
    }
    if (background !== "") {
        return { "background-color": background, "color": text_color }
    } else {
        return { "color": text_color }
    }
}